module.exports = __webpack_public_path__ + "img/info_circle_outline_black.1a02e811.svg";